import React from "react";

// Lightweight markdown -> HTML for AI research output
function inline(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`(.+?)`/g, "<code>$1</code>");
}

export const Markdown = ({ content = "" }) => {
  const lines = content.split("\n");
  const blocks = [];
  let list = [];

  const flush = () => {
    if (list.length) {
      blocks.push(`<ul>${list.map((l) => `<li>${inline(l)}</li>`).join("")}</ul>`);
      list = [];
    }
  };

  lines.forEach((raw) => {
    const line = raw.trimEnd();
    if (/^##\s+/.test(line)) { flush(); blocks.push(`<h2>${inline(line.replace(/^##\s+/, ""))}</h2>`); }
    else if (/^###\s+/.test(line)) { flush(); blocks.push(`<h3>${inline(line.replace(/^###\s+/, ""))}</h3>`); }
    else if (/^>\s?/.test(line)) { flush(); blocks.push(`<blockquote>${inline(line.replace(/^>\s?/, ""))}</blockquote>`); }
    else if (/^[-*]\s+/.test(line)) { list.push(line.replace(/^[-*]\s+/, "")); }
    else if (/^\d+\.\s+/.test(line)) { list.push(line.replace(/^\d+\.\s+/, "")); }
    else if (line === "") { flush(); }
    else { flush(); blocks.push(`<p>${inline(line)}</p>`); }
  });
  flush();

  return <div className="markdown-body text-[15px] text-foreground/90" dangerouslySetInnerHTML={{ __html: blocks.join("") }} />;
};
